var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6339 14.0005L22.2839 7.35052C22.7505 6.88385 22.7505 6.18385 22.2839 5.71719C21.8172 5.25052 21.1172 5.25052 20.6505 5.71719L14.0005 12.3672L7.35052 5.71719C6.88385 5.25052 6.18385 5.25052 5.71719 5.71719C5.25052 6.18385 5.25052 6.88385 5.71719 7.35052L12.3672 14.0005L5.71719 20.6505C5.25052 21.1172 5.25052 21.8172 5.71719 22.2839C5.95052 22.5172 6.30052 22.6339 6.53385 22.6339C6.76719 22.6339 7.11719 22.5172 7.35052 22.2839L14.0005 15.6339L20.6505 22.2839C20.8839 22.5172 21.2339 22.6339 21.4672 22.6339C21.7005 22.6339 22.0505 22.5172 22.2839 22.2839C22.7505 21.8172 22.7505 21.1172 22.2839 20.6505L15.6339 14.0005Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.65d80d1407388c97f6fb34a698004953.svg";
export { ForwardRef as ReactComponent };